module.exports = __webpack_public_path__ + "img/legend_point_02.a4c2b136.png";